import { DestinationEvent } from '@eventbrite/event-renderer';
import { sdkRequest } from '@eventbrite/http';
import { DateType } from '../constants/dates';

export function searchPromotedEvents(
    payload: PromotedEventsSearchApiPayload,
): Promise<DestinationEvent[]> {
    return sdkRequest('/api/v3/promoted/events', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
}

export interface PromotedEventsSearchApiPayload {
    slots: number;
    page: number;
    interface: string;
    app: string;
    search: PromotedEventsSearchFiltersApiPayload;
}

export interface PromotedEventsSearchFiltersApiPayload {
    dates?: DateType[];
    date_range?: {
        from: string;
        to: string;
    };
    client_timezone: string;
    q?: string;
    price?: string;
    languages: string[];
    tags?: string[];
    related_event?: {
        id: number;
        name: string;
        summary: string;
    };
    place: {
        place_id?: number;
        is_online?: boolean;
        geo_point?: {
            lon: number;
            lat: number;
            radius: number;
        };
    };
}
